import { useState, useEffect } from "react";
import { useAdors } from "context/AdorsContext";
import { Modal, Card } from 'react-bootstrap';

// Set state of validation
export default function AdorElGraphic({ ador, validate, updateAdorValue }) {

  useEffect(() => {
    // Check required with ador.is_required
    if (ador.is_required) {
      FieldValidation([ador.ador_name]);
      updateAdorValue(ador.ador_name, "is_invalid", 1);
    }
    // Check format with ador.validation
  }, [validate]);

  const handleChange = (e) => {
    e.stopPropagation();
    // Validate using ador config

    // update ador Pass validation
    updateAdorValue(e.target.name, "user_value", e.target.value);

  }

  return (
    <div className="row">
      <div className="col">
        <label className="form-label">{ador.label}</label>
        <input type="file" className="form-control" id={ador.ador_name} name={ador.ador_name} onChange={handleChange} />
        <div className="invalid-feedback"></div>
      </div>
    </div>
  );
}
